@if (label) {
  <span
    class="bracket-select-label form-control-label"
    [class.required]="required()"
  >
    {{ label }}
  </span>
}
<p-multiselect
  [selectAll]="null"
  [options]="weightBracketList"
  [disabled]="disabled()"
  [ngModel]="selectedWeightBrackets"
  (ngModelChange)="selectedWeightBrackets = $event; onSelectionChange()"
  maxSelectedLabels="1"
  placeholder="Please select"
  selectedItemsLabel="{0} selected"
  [appendTo]="appendTo()"
  [class]="required() && !selectedWeightBrackets?.length ? 'has-error' : ''"
>
</p-multiselect>
